module.exports = __webpack_public_path__ + "img/pr-48.111c15a7.png";